import axios from 'axios';

const routesApis = [];


export default {
  
  getFindByCategory() {
    return axios.get('menu-find-by-category');
  },
  
  
  getFindByService() {
    return axios.get('menu-find-by-service');
  },
  
  getRoutes() {
      
        return axios.all([this.getFindByCategory()]);

  }
  
}